import { useEffect } from "react";

import { useMediaPreviewModal } from "@/components/media-preview-modal/useMediaPreviewModal";
import { getExtensionFromFilename } from "@/utils/getExtensionFromMime";

import type { AssetFileRef } from "../components/upload-assets/types";

/** Registers `files` with the surrounding preview modal; returns the opener. */
export function useFilePreview(
  files: AssetFileRef[],
): (attachmentId: number) => void {
  const { openModal, setMediaItems } = useMediaPreviewModal();

  useEffect(() => {
    setMediaItems(
      files.map((file) => ({
        extension: getExtensionFromFilename(file.name),
        id: String(file.attachmentId),
        name: file.name,
        url: file.url,
      })),
    );
  }, [files, setMediaItems]);

  return (attachmentId: number) => openModal(String(attachmentId));
}
